import ObjectIdGenerator from '../modules/objectidgenerator';

const FINLAND_COUNTRY_ID = 246;

class Address {
    constructor(json) {
        if (json != null) {
            this.id = json.id;
            this.name = json.name;
            this.streetAddress = json.streetAddress;
            this.zipCode = json.zipCode;
            this.city = json.city;
            this.country = json.country;
        } else {
            this.id = 0;
            this.name = '';
            this.streetAddress = '';
            this.zipCode = null;
            this.city = '';
            this.country = { countryId: 246 };
        }
    }

    isValid() {
        if (!this.streetAddress || this.streetAddress.length < 0) return false;
        if (!this.city || this.city.length < 0) return false;
        if (!this.zipCode || this.zipCode.length < 0) return false;
        // Postal code data is only available for Finland, so the strict 5-digit format
        // can only be enforced for Finnish addresses. Other countries just require a non-empty value.
        if (this.isFinland() && this.zipCode.length !== 5) return false;

        return true;
    }

    isFinland() {
        return !!this.country && this.country.countryId === FINLAND_COUNTRY_ID;
    }

    static areEqual(one, other) {
        if (one.name !== other.name) return false;
        if (one.streetAddress !== other.streetAddress) return false;
        if (one.zipCode !== other.zipCode) return false;
        if (one.city !== other.city) return false;
        return true;
    }

    static NewObject() {
        const promise = new Promise(function (resolve, reject) {
            const address = new Address();
            ObjectIdGenerator.newId()
                .then(function (id) {
                    address.id = id;
                    resolve(address);
                })
                .catch(function (err) {
                    console.log(err);
                    reject();
                });
        });
        return promise;
    }
}

export default Address;
